import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "supplement-body ion-padding" }
const _hoisted_2 = { class: "supplement-offer-link" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "supplement-payee" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "supplement-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Дополнение к оферте", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background privacy-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "supplement-intro" }, " Настоящее дополнение к договору оферты регулирует участие в платных мероприятиях (событиях) в приложении «Лига тренеров». ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("h2", null, "1. Описание услуги", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("p", null, " Приложение «Лига тренеров» может организовывать платные мероприятия (события). Оплата участия производится через платёжный сервис ЮKassa (ЮMoney). Приложение выступает посредником: денежные средства принимаются на счёт оператора приложения и в соответствии с договором между оператором и организатором мероприятия переводятся организатору (получателю). ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h2", null, "2. Порядок оплаты", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("ul", null, [
              _createElementVNode("li", null, "Пользователь регистрируется на платное событие и при необходимости выбирает тариф."),
              _createElementVNode("li", null, "После регистрации пользователь может оплатить участие, перейдя по ссылке оплаты. Оплата осуществляется в соответствии с правилами ЮKassa."),
              _createElementVNode("li", null, "Факт успешной оплаты фиксируется в приложении. При наличии технической возможности пользователю предоставляется QR-код для подтверждения оплаты и входа на мероприятие.")
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("h2", null, "3. Возвраты", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", null, " Возврат средств за оплаченное участие в событии осуществляется в соответствии с правилами организатора мероприятия и действующим законодательством РФ. Запрос на возврат пользователь направляет оператору или организатору (способ указан в описании события или на сайте оператора). ", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("h2", null, "4. Согласие с условиями", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", null, " Нажимая кнопку «Оплатить» при оплате участия в платном событии, пользователь подтверждает, что ознакомился с условиями оферты и настоящим дополнением о платных событиях и согласен с ними. ", -1)),
            _createElementVNode("p", _hoisted_2, [
              _cache[2] || (_cache[2] = _createTextVNode(" Полный текст договора оферты: ", -1)),
              _createElementVNode("a", {
                href: _ctx.offerUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "supplement-link"
              }, _toDisplayString(_ctx.offerUrl), 9, _hoisted_3)
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("h2", null, "5. Реквизиты исполнителя", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.LEGAL.payee.fullName), 1)
              ]),
              _createElementVNode("p", null, "ИНН " + _toDisplayString(_ctx.LEGAL.payee.inn), 1),
              _createElementVNode("p", null, "ОГРНИП " + _toDisplayString(_ctx.LEGAL.payee.ogrnip), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.LEGAL.payee.address), 1),
              _createElementVNode("p", null, "Тел.: " + _toDisplayString(_ctx.LEGAL.payee.phone), 1),
              _createElementVNode("p", null, [
                _cache[3] || (_cache[3] = _createTextVNode("E-mail: ", -1)),
                _createElementVNode("a", {
                  href: 'mailto:' + _ctx.LEGAL.payee.email,
                  class: "supplement-link"
                }, _toDisplayString(_ctx.LEGAL.payee.email), 9, _hoisted_5)
              ])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "supplement-footer" }, " © Национальная лига тренеров ", -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}